import { apiFetch } from './client';
import type { ContinuityActionStatus, HRContinuityAction, HRContinuityTrends, HRConversationDue } from '$lib/types';

// hrContinuityApi backs the HR Continuity view (Phase 4, spec 5.7) — a
// deliberately restricted surface, distinct from the admin one (see
// internal/api/handlers/hr_continuity.go). Every route is RequireHR-gated.
export const hrContinuityApi = {
  myActions: () => apiFetch<HRContinuityAction[]>('/hr/continuity/my_actions'),
  updateMyAction: (id: number, status: ContinuityActionStatus) =>
    apiFetch<HRContinuityAction>(`/hr/continuity/my_actions/${id}`, { method: 'PATCH', body: JSON.stringify({ status }) }),
  conversationsDue: () => apiFetch<HRConversationDue[]>('/hr/continuity/conversations_due'),
  trends: () => apiFetch<HRContinuityTrends>('/hr/continuity/trends')
};
